import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';

import { MatSnackBar } from '@angular/material/snack-bar';

export interface BookingAssistantResponse {
  success: boolean;
  data: {
    reply: string;
    slot_id: number | null;
    missing_information: string[];
    booking_ready: boolean;
  };
  message?: string;
}

export interface HomeAssistantResponse {
  success: boolean;
  data: {
    reply: string;
    specialty_id: number | null;
    specialty: string | null;
    appointment_date: string | null;
    time_of_day: 'morning' | 'afternoon' | 'evening' | null;
  };
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLoginOtp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isRegisterOtp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  doctors: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  monthSlots: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  slots: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  isSlotsLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  dataOcr: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  tokenOcr: string = '';

  //IDfy variables
  private idfyApiKey = 'e1e30e77-e336-41b7-801a-8505fce27b9d';
  private idfyAccountId = 'd9906d8f4f7b/019d0d7d-6bc6-4cf2-aab4-95b3050d9fc5';
  private urlIdfy = 'https://eve.idfy.com/v3/tasks/sync/extract/ind_passport';
  private idfyTaskId = '74f4c926-250c-43ca-9c53-453e87ceacd1';
  private idfyGroupId = '8e16424a-58fc-4ba4-ab20-5bc8e7c3c41e';

  constructor(private http: HttpClient, private storage: StorageService, public router: Router, private snackBar: MatSnackBar) { }

  //Api call for register
  async register(details: object) {
    return await lastValueFrom(this.http
      .post(
        environment.apiUrl + `/register`,
        details
      ));
  }

  //Api call for register verification
  registerVerification(details: object) {
    return this.http
      .post(
        environment.apiUrl + `/verification/validate`,
        details
      );
  }

  //Api call for login
  login(details: object) {
    return this.http
      .post(
        environment.apiUrl + `/login`,
        details
      );
  }

  //Api call for login verification
  loginVerification(details: object) {
    return this.http
      .post(
        environment.apiUrl + `/validate/otp`,
        details
      );
  }

  //Api call to get all hospitals
  getAllHospitals() {
    return this.http
      .get(
        environment.apiUrl + `/hospitals`
      );
  }

  //Api call to get hospitals based on hospital id
  getHospital(hospitalId: string) {
    return this.http
      .get(
        environment.apiUrl + `/hospitals/${hospitalId}`
      );
  }

  //Api call to get all branches
  getBranches() {
    return this.http
      .get(
        environment.apiUrl + `/branches`
      );
  }

  //Api call to get all branches based on Hospital
  getHospitalBranches(hospitalId: string) {
    return this.http
      .get(
        environment.apiUrl + `/branches/hospital/${hospitalId}`
      );
  }

  //Api call to get specialties/Departments
  getDepartments() {
    return this.http
      .get(
        environment.apiUrl + `/specialties`
      );
  }

  //Api call to get all departments based on Hospital
  getHospitalDepartments(hospitalId: string) {
    return this.http
      .get(
        environment.apiUrl + `/specialties?hospitalId=${hospitalId}`
      );
  }

  geAllSpecialties() {
    return this.http
      .get(
        environment.apiUrl + `/specialties`
      );
  }

  //Api call to get all departments based on Hospital Branches
  getBranchDepartments(branchId: string) {
    return this.http
      .get(
        environment.apiUrl + `/specialties?branchId=${branchId}`
      );
  }

  // Api call for getting patients
  // getAllPatients() {
  //   return this.http 
  //     .get(
  //       environment.apiUrl + `/bookingdetails/patients`
  //     )
  // }

  //Api call to get doctors according to Hospital
  getHospitalDoctorsList(hospitalId: string) {
    return this.http
      .get(
        environment.apiUrl + `/entities/?hospitalId=${hospitalId}`
      );
  }

  //Api call to get doctors according to search
  getBranchDoctorsList(params:any) {
    return this.http
      .get(
        environment.apiUrl + `/entities`, {params}
      );
  }

  //Api call to get All specialties
   getAllSpecialities() {
    return this.http 
      .get(
        environment.apiUrl + `/specialties`
      )
  }

  getAllSpecialitiesForAssistant() {
    return this.http.get(
      environment.apiUrl + `/specialties`,
      { params: { perPage: '100' } }
    );
  }

  //Api call to get Booking details theat is old patient bookings
  getAllPatientDetails() {
    return this.http 
      .get(
        environment.apiUrl + `/bookingdetails/patients`
      )
  }

  //Api call to get doctor details according to id
  getDoctorDetails(doctorId: any) {
    return this.http
      .get(
        environment.apiUrl + `/entities/${doctorId}`
      );
  }

  //Api call to get booking details
  getPatientDetails(patientId: string) {
    return this.http
      .get(
        environment.apiUrl + `/bookingdetails/patient/details/${patientId}`
      );
  }


   //Api call to get All specialties
  //  getDoctorsSpecialties(specialtyId:string) {
  //   let data = {
  //     "id": specialtyId,
  //   };
  //   return this.http
  //     .post(
  //       environment.apiUrl + `/getdoctors/specialty`,data
  //     );
  // }

  //Api call to get month slots
  async getMonthSlots(month: number | null, child: boolean, doctorId: any, doctorBranchId: any) {
    const data: any = {
      "child": child.toString(),
      "entity_id": doctorId,
      "branch_id": doctorBranchId,
    };
    if (month !== null && month !== undefined) {
      data.month = month;
    }
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/slots/pediatric-friendly`, data
        ));
    } catch (error) {
      return error;
    }
  }

  async getAssistantMonthSlots(month: number, doctorId: any, doctorBranchId: any) {
    const data = { month, entity_id: doctorId, branch_id: doctorBranchId };
    try {
      return await lastValueFrom(this.http.post(environment.apiUrl + `/slots/bymonth`, data));
    } catch (error) {
      return error;
    }
  }

  //Api call to get slots by date
  getSlotsByDate(date: any, isChild: boolean, doctorId: any, doctorBranchId: any, patientId: any, revisit: any) {
  
    if(patientId == null){
      let data = {
        "date": date,
        "child": isChild.toString(),
        "entity_id": doctorId,
        "branch_id": doctorBranchId,
        "is_revisit": revisit
        // "patient_id": patientId
      };
      return this.http
      .post(
        environment.apiUrl + `/slots/bydate`, data
      );
  }else {
    let data = {
      "date": date,
      "child": isChild.toString(),
      "entity_id": doctorId,
      "branch_id": doctorBranchId,
      "patient_id": patientId,
      "is_revisit": revisit
    };
    return this.http
      .post(
        environment.apiUrl + `/slots/bydate`, data
      );
  } 
  }

  bookingAssistant(message: string) {
    return this.http.post<BookingAssistantResponse>(
      environment.apiUrl + `/ai/booking-assistant`,
      { message }
    );
  }

  homeBookingAssistant(message: string) {
    return this.http.post<HomeAssistantResponse>(
      environment.apiUrl + `/ai/home-assistant`,
      { message, mode: 'home' }
    );
  }

  //Api call for booking
  async booking(details: any) {
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/response/booking`, details
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for existuing booking
  async existingPatientBooking(details: any) {
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/response/existing/booking`, details
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for booking confirmation
  async bookingConfirm(details: any) {
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/response/payment`, details
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for saving form
  async saveForm(details: any) {
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/response`, details
        ));
    } catch (error) {
      return error;
    }
  }


  //Api call to get booking details of parent user acoording to booking number or phone number
  getBookingIdDetails(bookingId: string) {
    let data = {
      "booking_no": bookingId
    };
    return this.http
      .post(
        environment.apiUrl + `/booking/bybookingno`, data
      );
  }

   //Api call to get booking details of parent user acoording to booking id
   getBookingDetails(bookingId: string) {
    let data = {
      "phone_booking_no": bookingId
    };
    return this.http
      .post(
        environment.apiUrl + `/booking/bybooking-phone-no`, data
      );
  }

  //Api call to Send Common Otp
  getOtp(storedData: string) {
    return this.http
      .post(
        environment.apiUrl + `/otp/send-otp`, storedData
      );
  }

  //Api call to Verify Common Otp
  verifyOtp(storedData: string) {
    return this.http
      .post(
        environment.apiUrl + `/otp/validate-otp`, storedData
      );
  }

  //Api call to Update Profile
  updateUserProfile(storedData: any) {
    return this.http
      .post(
        environment.apiUrl + `/update-profile`, storedData
      );
  }

  //Api call to Reschedule Specific applicant according to applicant id
  rescheduleSpecificAppointment(specificRescheduleData: string) {
    return this.http
      .post(
        environment.apiUrl + `/response/applicant/reschedule`, specificRescheduleData
      );
  }

  //Api call to Reschedule Entire Booking
  rescheduleEntireAppointment(storedData: any) {
    return this.http
      .post(
        environment.apiUrl + `/response/booking/reschedule`, storedData
      );
  }
  //Api call to Cancel Specific applicant according to applicant id
  cancelSpecificAppointment(specificCancelData: string) {
    return this.http
      .post(
        environment.apiUrl + `/response/applicant/cancel`, specificCancelData,
      );
  }

  //Api call to Cancel Entire booking by booking id
  cancelEntireAppointment(entireCancelData: string) {
    return this.http
      .post(
        environment.apiUrl + `/response/booking/cancel`, entireCancelData
      );
  }

  //Api call to get forms by id
  async getFormById(id: string) {
    try {
      return await lastValueFrom(this.http
        .get(
          environment.apiUrl + `/forms/${id}`
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for update application
  async updateApplication(details: any) {
    try {
      return await lastValueFrom(this.http
        .put(
          environment.apiUrl + `/response/${details.applicant_id}`, details.applicants
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for offline booking
  async offlineBookingVerify(token: string) {
    let data = {
      "token": token
    };
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/booking-token/verify`, data
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for fetching Home page text
  getHomeText() {
    return this.http
      .get(
        environment.apiUrl + `/home/text`
      );
  }

  //To Fetch Dynamic form's Dynamic field data
  getDynamicUrlContent(url: string): any {
    return this.http
      .get(
        environment.apiUrl + url
      );
  } 

  //To fetch OCR details 
  async getIdfyData(file: any) {
    const formData = {    
        'document': file
    };
    try {
      return await lastValueFrom(this.http
        .post(
          environment.apiUrl + `/ocr/passport`, formData, {
          headers: {
            'Content-Type': 'application/json',                     }
        }
        ));
    } catch (error) {
      return error;
    }
  }

  //Api call for Payment log
  paymentLog(paymentLogData: any) {
    return this.http
      .post(
        environment.apiUrl + `/response/paymentlog`, paymentLogData
      );
  }

  //Api call for Getting Razorpay Key
  getRazorpayKey() {
    return this.http
      .get(
        environment.apiUrl + `/razorpay/key`
      );
  }

  //Api call for logout
  logout() {
    this.storage.remove('token');
    this.storage.remove('med_participant_booking_details');
    this.storage.remove('user_data');
    this.storage.remove('user_id');
    this.isAuthenticated.next(false);
    this.isLoginOtp.next(false);
    this.isRegisterOtp.next(false);
    this.isLogin.next(true);
    this.router.navigateByUrl('/', { replaceUrl: true });
    this.snackBar.open('You have been logged out Successfully', '', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'text-center'
    });
    // Refresh the page
    // window.location.reload();
  }


}
